<app-field-container [field]="this">
  <div class="row">
    @for (choice of choices(); track choice?.value) {
      <div class="col-12 gy-1 choice-item">
        <button
          type="button"
          class="btn btn-block text-start"
          [class.active]="value() === choice.value"
          [disabled]="disabled()"
          (click)="setValue(choice.value)">
          @if (choice.icon) {
            <lucide-icon [img]="choice.icon"></lucide-icon>
          }
          <span class="label">
            {{ choice.text }}
          </span>
          @if (choice.description) {
            <p class="desc">
              {{ choice.description }}
            </p>
          }
        </button>
      </div>
    }
  </div>
</app-field-container>
